import { render, staticRenderFns } from "./book-interview.vue?vue&type=template&id=3968c35a&scoped=true&"
import script from "./book-interview.vue?vue&type=script&lang=js&"
export * from "./book-interview.vue?vue&type=script&lang=js&"
import style0 from "./book-interview.vue?vue&type=style&index=0&id=3968c35a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968c35a",
  null
  
)

export default component.exports